import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ContactValuePanel, DeptSelectDialog } from '@fx-ui/platform-sdk';
import { ContactsFooter } from '../../../../../components';
import { DataType, DeptItem, DeptStatus, DeptType } from '@fx-ui/jdy-design-biz';
import { isEmpty, map, EMPTY_FN, find } from '@libs/shared';
import { TRACKER } from '../../../../../constants';
import { tracker } from '../../../../../utils';
import { globalState } from '../../../../../models';

interface PluginDeptSelectProps {
    style?: React.CSSProperties;
    valuePanelClassName?: string;
    disabled?: boolean;
    defaultValue?: string[];
    onOk?: (value: string[] | undefined) => void;
}

const PluginDeptSelect: React.FC<PluginDeptSelectProps> = (props) => {
    const { style, valuePanelClassName, disabled, defaultValue, onOk = EMPTY_FN } = props;

    const [dialogVisible, setDialogVisible] = useState(false);
    const [value, setValue] = useState<DeptItem[]>();

    useEffect(() => {
        if (isEmpty(defaultValue)) {
            setValue([]);
            return;
        }
        globalState.request?.onResolveContactDetails(defaultValue || []).then((data) => {
            const departments = data.departments || [];
            setValue(
                map(defaultValue, (_id) => {
                    const result = find(departments, {
                        _id
                    });
                    if (result) {
                        return result;
                    }
                    return {
                        _id,
                        type: DeptType.internal,
                        status: DeptStatus.dismission
                    } as any;
                })
            );
        });
    }, [defaultValue]);

    return (
        <div className="fx-plugin-dept-select" style={style}>
            <ContactValuePanel
                className={classNames('dept-value-panel', valuePanelClassName)}
                dataType={DataType.dept}
                items={value}
                tag={{
                    gap: 2
                }}
                disabled={disabled}
                onClick={() => setDialogVisible(true)}
            />
            <DeptSelectDialog
                visible={dialogVisible}
                value={value}
                onCancel={() => setDialogVisible(false)}
                onOk={(departments) => {
                    const departmentIds = map(departments, '_id');
                    onOk(departmentIds);
                    setDialogVisible(false);
                    tracker(TRACKER.MEMBERSELECT_CONTENT, {
                        p1: '',
                        p2: departmentIds.join(',')
                    });
                }}
                footer={<ContactsFooter />}
                onFetchInternalDepartments={globalState.request?.onFetchDepartments}
            />
        </div>
    );
};

export default PluginDeptSelect;
